module.exports = __webpack_public_path__ + "img/Attack_ultimategoldendragon.f4553000.png";